import React, { useState, useEffect } from "react";
import { Select, Spin } from "antd";
import useDebounce from "../../hooks/useDebounce";
import { Label } from "../globals";

function DebounceSelect({
  fetchOptions,
  debounceTimeout = 600,
  isMultiple = false,
  initialValue,
  includeEmptyOption = false,
  emptyOptionLabel = "",
  isEditable = false,
  onEdit,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState("");
  
  useDebounce(() => actionFunc(), debounceTimeout, [searchVal]);

  useEffect(() => {
    if (props.options) {
      setOptions(props.options);
    }
  }, [props.options]);

  useEffect(() => {
    if (initialValue) {
      setFetching(true);
      fetchOptions(initialValue).then((initialOptions) => {
        setOptions(initialOptions);
        setFetching(false);
      });
    }
  }, [initialValue, fetchOptions]);

  const actionFunc = () => {
    if (searchVal === "") {
      setOptions([]);
      setFetching(false);
      return;
    }

    setOptions([]);
    setFetching(true);
    fetchOptions(searchVal).then((newOptions) => {
      setOptions(newOptions);
      setFetching(false);
    });
  };

  const handleSelectChange = (value, option) => {
    if (isEditable) {
      setEditedValue(value);
      setIsEditing(true);
    }
    if (props.onChange) {
      props.onChange(value, option);
    }
  };

  const handleBlur = () => {
    if (isEditable && isEditing && onEdit) {
      onEdit(editedValue);
      setIsEditing(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isEditable && isEditing && onEdit) {
      onEdit(editedValue);
      setIsEditing(false);
    }
  };

  // Add empty option if includeEmptyOption is true
  const finalOptions = includeEmptyOption
    ? [{ label: emptyOptionLabel, value: "" }, ...options]
    : options;

  return (
    <>
      {!!props.label && (
        <Label
          className="text-sm-label"
          required={props.required}
          error={props.error || props.warning}
        >
          {props.label}
        </Label>
      )}

      <Select
        mode={isMultiple ? "multiple" : undefined}
        labelInValue={!isEditable}
        filterOption={false}
        onSearch={(val) => setSearchVal(val)}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        dropdownMatchSelectWidth={false}
        {...props}
        value={isEditable && isEditing ? editedValue : props.value || undefined}
        onChange={handleSelectChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        options={finalOptions}
      />
      {props.error && <div className="text-danger">{props.error}</div>}
    </>
  );
}

export default DebounceSelect;
